import { 
  Box,
  Center,
  Tag,
  Stack,
  Text, 
  VStack
} from '@chakra-ui/react'
import React from 'react'
import Answer from './Answer'

const Question = ({ question, updateSelection, quizOver, swapUsed, ...rest}) => {
  const answerElements = question.answers.map((answer,index) =>{
    const isSelected = answer === question.selected
    const isCorrect = answer === question.correct_answer
    return(
        <Answer 
            key={index} 
            answer={answer} 
            updateSelection={updateSelection} 
            qid={question.id} 
            isSelected={isSelected} 
            isCorrect={isCorrect}
            quizOver={quizOver}
            />
)});

  return (
    <Box className='question' w={'100%'} p={2} {...rest} >
      <VStack>
        <Tag opacity={'0.6'} fontStyle={'italic'} size={'sm'} variant='outline' colorScheme='red'>
          {question.category}
        </Tag>
        <Center>
          <Text dangerouslySetInnerHTML={{__html:question.question}}></Text>
        </Center>
        
      </VStack>
      <Center>
        <Stack py={4} direction={{base:'column', md:'row'}} maxW={{base:'80%', md:'100%'}} spacing={4}>
          {answerElements}
        </Stack>
      </Center>
      
    </Box>
  )
}

export default Question